import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, FileText, ScrollText } from "lucide-react";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function LegalIndex() {
  const [pages, setPages] = useState(null);
  useEffect(() => {
    document.title = "Legal & Policies — Suffle Online";
    api.get("/legal").then((r) => setPages(r.data.pages || [])).catch(() => setPages([]));
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="legal-index">
      <header className="border-b border-slate-100">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-4 sm:px-6">
          <Link to="/"><Logo variant="lg" /></Link>
          <Link to="/" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-blue-600"><ArrowLeft className="h-4 w-4" /> Back to home</Link>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-4 py-12 sm:px-6">
        <div className="flex items-center gap-2"><ScrollText className="h-6 w-6 text-blue-500" /><h1 className="font-brand text-3xl font-bold text-slate-900">Legal & Policies</h1></div>
        <p className="mt-2 text-sm text-slate-500">All published Suffle Online policies. Operated by Naucera Travel Private Limited.</p>
        {pages === null ? (
          <div className="mt-6 h-40 animate-pulse rounded-2xl bg-slate-50" />
        ) : pages.length === 0 ? (
          <p className="mt-6 text-slate-500">No published policies yet.</p>
        ) : (
          <ul className="mt-6 grid gap-2 sm:grid-cols-2" data-testid="legal-index-list">
            {pages.map((p) => (
              <li key={p.slug}>
                <Link to={`/legal/${p.slug}`} data-testid={`legal-index-${p.slug}`}
                  className="flex items-center gap-3 rounded-xl border border-slate-200 p-3 text-sm text-slate-700 transition hover:border-blue-300 hover:bg-blue-50/40">
                  <FileText className="h-4 w-4 shrink-0 text-slate-400" />
                  <span className="flex-1">{p.title}</span>
                  {p.version && <span className="text-xs text-slate-400">v{p.version}</span>}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </main>
    </div>
  );
}
